export default __webpack_public_path__ + "static/shooting-stk-5f4e80916471844a2a38caafb1939492.jpg";